import React from 'react';
import { Text, Section, Link } from '@react-email/components';
import Layout, { LayoutTranslations } from './components/Layout';

export interface AppointmentCancelledTranslations {
  title: string;
  greeting: string;
  body: string;
  labelDate: string;
  labelTime: string;
  labelWith: string;
  reschedule: string;
  ctaText: string;
  signOff: string;
  teamSignature: string;
  cancelledByVisitor: string;
  cancelledByExhibitor: string;
  layout: LayoutTranslations;
}

interface AppointmentCancelledProps {
  recipientName: string;
  otherPartyName: string;
  date: string;
  time: string;
  cancelledBy: 'visitor' | 'exhibitor';
  translations: AppointmentCancelledTranslations;
}

export default function AppointmentCancelled({
  recipientName,
  otherPartyName,
  date,
  time,
  cancelledBy,
  translations: tx,
}: AppointmentCancelledProps) {
  const cancelledByLabel = cancelledBy === 'visitor' ? tx.cancelledByVisitor : tx.cancelledByExhibitor;

  return (
    <Layout previewText={`${tx.title} - ${otherPartyName}`} translations={tx.layout}>
      <Text style={heading}>{tx.title}</Text>
      <Text style={paragraph}>{tx.greeting} {recipientName},</Text>
      <Text style={paragraph}>
        {tx.body
          .replace('{{name}}', otherPartyName)
          .replace('{{date}}', date)
          .replace('{{time}}', time)
          .replace('{{cancelledBy}}', cancelledByLabel)}
      </Text>

      <Section style={infoBox}>
        <Text style={infoLine}>{tx.labelDate}: {date}</Text>
        <Text style={infoLine}>{tx.labelTime}: {time}</Text>
        <Text style={infoLine}>{tx.labelWith}: {otherPartyName}</Text>
      </Section>

      <Text style={paragraph}>{tx.reschedule}</Text>

      <Section style={ctaContainer}>
        <Link href="https://siportevent.com/dashboard/appointments" style={ctaButton}>{tx.ctaText}</Link>
      </Section>

      <Text style={paragraph}>{tx.signOff}<br />{tx.teamSignature}</Text>
    </Layout>
  );
}

const heading: React.CSSProperties = { fontSize: '24px', fontWeight: 700, color: '#6b7280', margin: '0 0 20px 0' };
const paragraph: React.CSSProperties = { fontSize: '16px', lineHeight: '1.6', color: '#374151', margin: '0 0 16px 0' };
const infoBox: React.CSSProperties = { backgroundColor: '#f9fafb', borderLeft: '4px solid #9ca3af', padding: '16px 20px', margin: '20px 0', borderRadius: '0 4px 4px 0' };
const infoLine: React.CSSProperties = { fontSize: '15px', color: '#4b5563', margin: '0 0 8px 0' };
const ctaContainer: React.CSSProperties = { textAlign: 'center' as const, margin: '30px 0' };
const ctaButton: React.CSSProperties = { display: 'inline-block', padding: '14px 28px', backgroundColor: '#2563eb', color: '#ffffff', textDecoration: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '16px' };
